export default {"src":"/_next/static/media/lbsEquity.7d3da954.svg","height":484,"width":1646,"blurWidth":0,"blurHeight":0};